import type { PushPort } from "./types";

/** 웹 푸시는 없다(AC0-260 범위 밖). 권한은 늘 denied 로 보고 소프트 애스크·설정 행을 띄우지 않는다. */
export const webPush: PushPort = {
  async permission() {
    return "denied";
  },
  async requestPermission() {
    return "denied";
  },
  async register() {
    return null;
  },
  onOpened() {
    return () => undefined;
  },
};
